import {
  ActionValidation,
  BooleanValidation,
  StringValidation,
} from '../../../../utils/component-validations';
import { fn } from '@ember/helper';
import { isPresent } from '@ember/utils';
import { on } from '@ember/modifier';
import DestructiveButton from '../../action/button/destructive.gjs';
import PrimaryButton from '../../action/button/primary.gjs';
import SecondaryButton from '../../action/button/secondary.gjs';
import Super from '../../core/base.gjs';

export default class SpdsModalSharedFooterCta extends Super {
  arguments = [
    new ActionValidation({ optional: ['secondaryBtnAction'], required: ['primaryBtnAction'] }),
    new BooleanValidation({ optional: ['danger', 'primaryBtnDisabled', 'secondaryBtnDisabled'] }),
    new StringValidation({ optional: ['secondaryBtnText'], required: ['primaryBtnText'] }),
  ];
  componentName = 'Spds::Modal::Shared::FooterCta';

  get primaryBtnComponent() {
    return this.args.danger ? DestructiveButton : PrimaryButton;
  }

  get primaryBtnType() {
    return this.args.danger ? 'destructive' : 'primary';
  }

  get showSecondaryButton() {
    return isPresent(this.args.secondaryBtnAction) && isPresent(this.args.secondaryBtnText);
  }

  <template>
    {{#if this.showSecondaryButton}}
      <SecondaryButton
        @disabled={{@secondaryBtnDisabled}}
        data-test-spds-modal-shared-footer-cta-secondary-button
        {{on "click" (fn @secondaryBtnAction @close)}}
      >
        {{@secondaryBtnText}}
      </SecondaryButton>
    {{/if}}
    <this.primaryBtnComponent
      @disabled={{@primaryBtnDisabled}}
      data-test-spds-modal-shared-footer-cta-primary-button={{this.primaryBtnType}}
      {{on "click" (fn @primaryBtnAction @close)}}
      {{this.validateArguments}}
    >
      {{@primaryBtnText}}
    </this.primaryBtnComponent>
  </template>
}
